export default {
  /* LATAM */
  'JJ': 'https://www.latamtrade.com/pt_us/procom/perfis_tarifas',
  'LA': 'https://www.latamtrade.com/pt_us/procom/perfis_tarifas',
  '4M': 'https://www.latamtrade.com/pt_us/procom/perfis_tarifas',
  'LU': 'https://www.latamtrade.com/pt_us/procom/perfis_tarifas',
  'PZ': 'https://www.latamtrade.com/pt_us/procom/perfis_tarifas',
  'XL': 'https://www.latamtrade.com/pt_us/procom/perfis_tarifas',
  'LP': 'https://www.latamtrade.com/pt_us/procom/perfis_tarifas',


  /* GOL */
  'G3': 'https://www.voegol.com.br/pt/informacoes/tarifas?_ga=2.180712613.349617456.1583929159-1167600951.1578935819',

  /* Azul */
  'AD': 'https://www.voeazul.com.br/para-sua-viagem/informacoes-para-viajar/remarcacao--cancelamento'
}
